module.exports = __webpack_public_path__ + "static/media/DETERMINE-OBJECT.1cbf71fd.svg";